export class DateTimeNetUtils {
    public static readonly UnixEpochTicks: bigint = 621355968000000000n;
    public static readonly TicksPerMillisecond: bigint = 10000n;

    /**
     * Преобразует JavaScript Date в .NET тики
     * @param date - Дата для преобразования
     * @returns .NET тики (тики с 0001-01-01)
     */
    public static toNetTicks(date: Date): bigint {
        const unixMs: bigint = BigInt(date.getTime());
        return this.UnixEpochTicks + unixMs * DateTimeNetUtils.TicksPerMillisecond;
    }

    /**
     * Преобразует .NET тики в JavaScript Date
     * @param ticks - .NET тики (может быть bigint, string или number)
     * @returns JavaScript Date объект
     */
    public static fromNetTicks(ticks: bigint | string | number): Date {
        const ticksBigInt: bigint = BigInt(ticks);
        const unixMs: bigint = (ticksBigInt - DateTimeNetUtils.UnixEpochTicks) / DateTimeNetUtils.TicksPerMillisecond;
        return new Date(Number(unixMs));
    }

    /**
     * Получает Unix timestamp в миллисекундах
     * @param date - Дата для преобразования
     * @returns Unix timestamp в миллисекундах
     */
    public static toUnixMilliseconds(date: Date): number {
        return date.getTime();
    }

    /**
     * Преобразует Unix миллисекунды в Date
     * @param unixMilliseconds - Unix timestamp в миллисекундах
     * @returns JavaScript Date объект
     */
    public static fromUnixMilliseconds(unixMilliseconds: number): Date {
        return new Date(unixMilliseconds);
    }

    /**
     * Форматирует дату в ISO 8601 строку
     * @param date - Дата для форматирования
     * @returns ISO 8601 строка
     */
    public static format(date: Date): string {
        return date.toISOString();
    }
}
